import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);

const card = (
  <React.Fragment>
    <CardContent>

      <Typography variant="h5" component="div"  sx={{color:"#F8A03A"  }} gutterBottom>
      Konrad Wróbel
      </Typography>
      <Typography sx={{ fontSize: 14 }} color="text.secondary" mt={-1} gutterBottom>
      Head of Design
      </Typography>
      <Typography variant="body2">
      Mob.: +48 602 751 436
      </Typography>
      <Typography variant="body2">
      e-mail: konrad@aluflam.dk
      </Typography>
      <Typography variant="body2">
      skype: ALUFLAM Konrad_wrobel
      </Typography>
    </CardContent>
  </React.Fragment>
);

export default function customCard() {
  return (
    <Box sx={{ width: 275, height:'auto' }}>
      <Card variant="outlined">{card}</Card>
    </Box>
  );
}
